module.exports = __webpack_public_path__ + "withdraw_saw_button_stratum.svg?55a8306d761dd6c36996c59898a77a07";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw_saw_button_stratum.svg
// module id = 962
// module chunks = 2